<template>
  <div class="main">
    <div class="picture" >
      <van-swipe :autoplay="3000" :show-indicators="false">
        <van-swipe-item v-for="(item, index) in banner_img" :key="index">
          <van-image
            class="banner_img"
            width="100%"
            :src="$global.account_url + item"
          />
        </van-swipe-item>
      </van-swipe>
    </div>
    <div class="toast">
      <div class="banner_left">
        <img
          class="toast_img"
          width="80%"
          height="80%"
          :src="$global.account_url + hsopInfo.hosp_icon"
        />
      </div>
      <div class="banner_right">
        <div class="font_middle">{{ hsopInfo.hospital_name }}</div>
        <div class="font_small">{{ hsopInfo.hospital_address }}</div>
      </div>
    </div>
    <div class="incos">
      <van-grid :column-num="3">
        <van-grid-item
          v-for="(item, index) in icons"
          :key="index"
          :icon="$global.account_url + item.pic"
          :text="item.name"
          @click="go_item(item)"
        />
      </van-grid>
    </div>
    <!-- <div class="btntext">
      技术支持与维护：达远软件
      <van-icon
        name="https://account.kmmds.top/datainfo_pic/dayuan_icon.jpg"
      ></van-icon>
    </div> -->
  </div>
</template>

<script>
import { mapState } from "vuex";
import setOptions from "../mixins/setOption";
import { Dialog } from "vant";
import area from "@/utils/area1.js";
export default {
  mixins: [setOptions],
  name: "index",
  data() {
    return {
      area,
      //轮播图
      banner_img: [],
      openid: "",
      //incons
      icons: [],
      //医院信息
      hsopInfo: {},
      hospInfo_url: "",
      testreg: null,
      openid:"",
      imgSrc: "data:image/jpeg;base64,"
    };
  },
  mounted() {
    if(this.$route.query.openid){
       this.openid=this.$route.query.openid
      this.$local.set("openid", this.openid);
    }
    this.init();
    // this.getregister();
    
  },
  methods: {
    showDialog() {
      Dialog.alert({
        title: "清廉承诺",
        messageAlign:"left",
        message:
          "为规范医疗秩序，严厉整治打击医疗乱象，我们承诺：\n一、不收红包。\n二、不收受礼品。\n三、不进行术中加价。\n四、不指定院外购药。\n五、不骗取医疗保障基金。\n六、不接受病人及亲属吃请。\n七、不进行过度检查、过度诊疗。\n八、不违规超量、超限制开具药品或耗材。\n九、不重复收费、捆绑收费、串换收费、超量收费。\n十、不参与供应商的推销活动和虚假医疗广告宣传。我们真诚接受广大人民群众和社会各界的监督。\n弥勒市卫生健康局监督举报电话：\n<span style='color:red'>0873—6122360，08733029379</span>\n弥勒市纪委市监委监督举报方式：\n电话举报：<span style='color:red'>0873—6122585</span>\n来信举报：弥勒市纪委市监委信访室  邮编：652399\n来访举报：弥勒市行政中心1—18室"
      }).then(() => {
        // on close
      });
    },
    async getregister() {
      await this.$getregister.getregister(this.testreg);
    },
    // 页面数据初始化
    async init() {
      //请求医院信息
      // 医院的名字、地址、banner图片、图标、功能
      try {
        this.$showLoad();
        this.isLoad = true;
        let url = "/index/getBasicIndex";
        await this.$axios_request.request_data(
          "nodeserver",
          url,
          "post",
          null,
          (data) => {
            console.log(data);
            //轮播图
            this.banner_img = data.data.banner;
            // icons
            this.icons = data.data.modules.content;
            //第三方地址
            this.hospInfo_url = data.data.modules.hosp_info_url;
            //医院名
            this.hsopInfo = data.data.basic_info;

            if(this.hsopInfo.wx_pub_id=="1014"){
              this.$router.push('/reservationIndex')
              return
            }
            if(this.hsopInfo.wx_pub_id=="1012"){
              this.showDialog()
            }
            // if(this.hsopInfo){
            //   this.$local.set("Hspname", this.hsopInfo.hospital_name);
            // }
            // console.log(this.hsopInfo)
            // console.log(this.hsopInfo.hospital_address);
            this.$hideLoad();
            this.getalret();
            //           Dialog.alert({
            //   message: '该公众号目前数据均为测试数据，你所录入的数据也将录入测试数据',
            // }).then(() => {
            //   // on close
            // });
            this.isLoad = false;
          }
        );
      } catch (error) {
        console.log(error);
        this.isLoad = false;
        this.$hideLoad();
        this.$toast.fail("网络连接失败");
      }
    },
  
    async getalret() {
    
      //请求医院信息
      // 医院的名字、地址、banner图片、图标、功能
      try {
        this.$showLoad();
        let url = "/hospitalconf/index/getHopitalNotice";
        let data = null;
        await this.$axios_request.request_data(
          "nodeserver",
          url,
          "post",
          null,
          (data) => {
            //  console.log(data.data)
            if (data.data.content) {
              Dialog.alert({
                message: data.data.content,
              }).then(() => {});
            }
            this.$hideLoad();
          }
        );
      } catch (error) {
        this.isLoad = false;
        this.$hideLoad();
        this.$toast.fail("网络连接失败");
      }
    },

    go_item(item) {
      if (item.type == "2") {
        if (!this.hospInfo_url) {
          this.$toast.fail("该功能暂未开放");
        }
        window.location.href = this.hospInfo_url;
        // "https://mp.weixin.qq.com/s/WfdsKVEdjK4b2SobWR9YPg";
        return;
      }
      if (item.type == "3") {
         let openId = this.$local.get("openid");
        let url = `${item.hospInfo_url}$openId=${openId}`
        window.location.href = item.hospInfo_url;
        return;
      }
      if (item.url == "#") {
        this.$toast.fail("该功能暂未开放");
      }
      if (this.openid) {
        this.$router.push(item.url + "?openid=" + this.openid);
      } else {
        this.$router.push(item.url);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
html,
body {
  padding: 0;
  margin: 0;
}
.main {
  max-height: 100vh;
  display: flex;
  flex-direction: column;
}
.picture {
  margin: 0px auto;
  width: 94%;
  margin-top: 8px;
  z-index: 0;
  .banner_img {
    width: 100%;
    height: 100%;
  }
}
.toast {
  z-index: 10;
  //   background-color: rbg(0,0,0);
  background-image: linear-gradient(#b7a7a7aa, #728adaaa);
  margin: 0px auto;
  width: 94%;
  height: 40px;
  margin-top: -45px;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  .banner_left {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    margin-left: 20px;
    margin-right: 6px;
    width: 40px;
    height: 40px;
  }
  .banner_right {
    color: #e7eafb;
    width: 70%;

    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    .font_middle {
      font-size: 10px;
    }
    .font_small {
      font-size: 6px;
    }
  }
}
.btntext {
  width: 100%;
  text-align: center;
  position: fixed;
  bottom: 0;
  font-size: 14px;
  line-height: 5vh;
  height: 5vh;
}

.incos {
  width: 94%;
  height: 80vh;
  margin: 0px auto;
  margin-top: 5px;
  overflow: scroll;
  margin-bottom: 5vh;
}
</style>